import React from 'react';
import { Table } from 'antd';
import PropTypes from 'prop-types';

// base class for render countries with users at dashboard controller
export default class CountryTable extends React.Component{

    Columns = [
        {
            'title': 'Country',
            'dataIndex': 'country'
        },
        {
            'title': 'Users',
            'dataIndex': 'total'
        }
    ];

    render() {
        return (
            <React.Fragment>
                <Table
                    bordered
                    loading={this.props.loading}
                    columns={this.Columns}
                    pagination={{
                        pageSize: 1000,
                        defaultCurrent: 0,
                        total: 1000,
                        current: 0,
                        hideOnSinglePage: true,
                    }}
                    dataSource={this.props.list}
                    rowKey={(item) => item.country}
                />
            </React.Fragment>
        );
    }

};

CountryTable.defaultProps = {
    loading: false,
    list: [],
};

CountryTable.propTypes = {
    loading: PropTypes.bool.isRequired,
    list: PropTypes.arrayOf(Object).isRequired,
};




// WEBPACK FOOTER //
// ./src/components/country.table.js